import { useEffect, useState } from 'react';
import { readStored, writeStored } from '../utils/storage';

/** useState die zichzelf veilig bewaart in localStorage; ongeldige waarden vallen terug op `initial`. */
export function usePersistentState<T>(
  key: string,
  initial: T,
  parse: (raw: unknown) => T | undefined,
) {
  const [value, setValue] = useState<T>(() => readStored(key, initial, parse));

  useEffect(() => {
    writeStored(key, value);
  }, [key, value]);

  return [value, setValue] as const;
}
